export default "__VITE_ASSET__CPnaZ_sy__"